declare namespace $ {

	type $mol_view__event_bog_builderui_dialog_1 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_builderui_dialog['close'] > ): ReturnType< $bog_builderui_dialog['close'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_builderui_dialog_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_dialog_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_dialog_4 = $mol_type_enforce<
		ReturnType< $bog_builderui_dialog['content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_button__title_bog_builderui_dialog_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_button__click_bog_builderui_dialog_6 = $mol_type_enforce<
		ReturnType< $bog_builderui_dialog['close'] >
		,
		ReturnType< $bog_builderui_button['click'] >
	>
	type $bog_builderui_button__title_bog_builderui_dialog_7 = $mol_type_enforce<
		ReturnType< $bog_builderui_dialog['confirm_title'] >
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_button__click_bog_builderui_dialog_8 = $mol_type_enforce<
		ReturnType< $bog_builderui_dialog['confirm'] >
		,
		ReturnType< $bog_builderui_button['click'] >
	>
	type $mol_view__sub_bog_builderui_dialog_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_card__sub_bog_builderui_dialog_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	export class $bog_builderui_dialog extends $bog_builderui_div {
		close( next?: any ): any
		Backdrop( ): $mol_view
		Surface_title( ): $mol_view
		Surface_text( ): $mol_view
		Surface_content( ): $mol_view
		Cancel( ): $bog_builderui_button
		confirm( next?: any ): any
		Confirm( ): $bog_builderui_button
		Surface_actions( ): $mol_view
		Surface( ): $bog_builderui_card
		showed( next?: boolean ): boolean
		title( ): string
		text( ): string
		content( ): readonly(any)[]
		confirm_title( ): string
		attr( ): ({ 
			'bog_builderui_dialog_showed': ReturnType< $bog_builderui_dialog['showed'] >,
		}) 
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=dialog.view.tree.d.ts.map